import { useMemo } from 'react';

export const useSelect = (
  optionData: Record<string, any>[],
  optionLabelKey: string,
  optionValueKey: string,
  label?: string,
) => {
  const options = useMemo(() => {
    const optionsList = optionData.map((option) => ({
      value: option[optionValueKey],
      label: option[optionLabelKey],
    }));
    if (label) {
      optionsList.unshift({ value: '', label: `Select ${label.toLowerCase()}` });
    }
    return optionsList;
  }, [optionData, optionValueKey, optionLabelKey, label]);

  return { options };
};
